// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JwJh","textarea":"styles_textarea__rYiAC"};